import styles from './ConfiguratorTitleBlock.module.scss';
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function TitleBlock({ title, text }) {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title} data-aos="fade-up">
        {title}
      </h1>
      <div className={styles.text} data-aos="fade-up" data-aos-delay="300">
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
}
